<template>
  <div class="analytics-filter">
    <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="项目选择">
        <a-select v-model="appKey" style="width: 200px" placeholder="选择项目">
          <a-select-option v-for="option in projectOptions" :key="option.value" :value="option.value">
            {{ option.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="事件选择">
        <div class="event-selector">
          <a-space>
            <a-select v-model="selectedEvent" style="width: 200px" placeholder="选择事件">
              <a-select-option v-for="option in eventOptions" :key="option.value" :value="option.value">
                {{ option.label }}
              </a-select-option>
            </a-select>
            <span>的</span>
            <a-select v-model="selectedMetric" style="width: 120px" placeholder="选择指标">
              <a-select-option v-for="option in metricOptions" :key="option.value" :value="option.value">
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-space>
          <div v-if="false">
            <a-space>
              <a-button type="primary" ghost>
                <a-icon type="plus" />
                指标
              </a-button>
              <a-button type="primary" ghost>
                <a-icon type="plus" />
                自定义指标
              </a-button>
            </a-space>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="全局筛选">
        <div class="filter-conditions">
          <div v-if="filterConditions.length > 0" class="conditions-wrapper">
            <div class="condition-group">
              <div class="condition-line-wrapper">
                <div class="condition-line">
                  <div class="line-top" />
                  <div class="line-bottom" />
                </div>
                <div v-if="filterConditions.length > 1" class="logic-type">
                  <a-radio-group v-model="logicType" size="small">
                    <a-radio-button value="and">且</a-radio-button>
                    <a-radio-button value="or">或</a-radio-button>
                  </a-radio-group>
                </div>
              </div>
              <div v-for="(condition, index) in filterConditions" :key="index" :class="{ 'has-connector': index < filterConditions.length - 1 }">
                <a-space>
                  <a-select v-model="condition.field" style="width: 160px" placeholder="选择字段">
                    <a-select-option v-for="option in fieldOptions" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </a-select-option>
                  </a-select>
                  <a-select v-model="condition.function" style="width: 100px" placeholder="选择操作符">
                    <a-select-option v-for="option in operatorOptions" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </a-select-option>
                  </a-select>
                  <a-input v-model="condition.params" placeholder="请输入值" style="width: 200px" />
                  <a v-if="false" @click="addCondition(index)"><a-icon type="plus" />并且满足</a>
                  <a @click="removeCondition(index)"><a-icon type="delete" /> 删除</a>
                </a-space>
              </div>
            </div>
          </div>
          <a @click="addCondition(-1)"><a-icon type="plus" />添加筛选</a>
        </div>
      </a-form-model-item>
      <a-form-model-item label="分组选择">
        <a-select v-model="byFields" mode="multiple" placeholder="选择分组" style="width: 200px">
          <a-select-option v-for="option in groupByOptions" :key="option.value" :value="option.value">
            {{ option.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="时间选择">
        <a-space>
          <a-select v-model="timeUnit" style="width: 120px">
            <a-select-option v-for="option in timeUnitOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </a-select-option>
          </a-select>
          <a-range-picker v-model="dateRange" style="width: 300px" :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD" value-format="YYYY-MM-DD HH:mm:ss" :ranges="ranges" @change="handleDateChange" />
        </a-space>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 1 }">
        <a-button type="primary" @click="handleQuery">查询</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import moment from 'moment';
import { projectOptions, eventOptions, metricOptions, fieldOptions, operatorOptions, groupByOptions, timeUnitOptions, defaultValues } from './config';

export default {
  name: 'AnalyticsFilter',
  data() {
    return {
      // 选项配置
      eventOptions,
      fieldOptions,
      metricOptions,
      projectOptions,
      operatorOptions,
      groupByOptions,
      timeUnitOptions,
      appKey: 'devops',
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
      selectedEvent: defaultValues.selectedEvent,
      selectedMetric: defaultValues.selectedMetric,
      logicType: 'and',
      filterConditions: [{ ...defaultValues.defaultCondition }],
      byFields: defaultValues.byFields,
      timeUnit: defaultValues.timeUnit,
      dateRange: [moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')]
    };
  },
  computed: {
    ranges() {
      return {
        今天: [moment().startOf('day'), moment().endOf('day')],
        昨天: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        本周: [moment().startOf('week'), moment().endOf('week')],
        本月: [moment().startOf('month'), moment().endOf('month')],
        近7天: [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
        近14天: [moment().subtract(13, 'days').startOf('day'), moment().endOf('day')],
        近30天: [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')]
      };
    }
  },
  methods: {
    addCondition(index) {
      const newCondition = { ...defaultValues.defaultCondition };
      if (index === -1) {
        this.filterConditions.push(newCondition);
      } else {
        this.filterConditions.splice(index + 1, 0, newCondition);
      }
    },
    removeCondition(index) {
      this.filterConditions.splice(index, 1);
    },

    handleDateChange() {},

    handleQuery() {
      const filters = {
        appKey: this.appKey,
        measures: {
          eventName: this.selectedEvent,
          aggregator: this.selectedMetric
        },
        filter: {
          relation: this.logicType,
          conditions: this.filterConditions
        },
        unit: this.timeUnit,
        fromDate: this.dateRange[0],
        toDate: this.dateRange[1],
        byFields: this.byFields
      };
      this.$emit('query', filters);
    }
  }
};
</script>

<style lang="less" scoped>
.analytics-filter {
  padding: 0px;

  .ant-form-item {
    margin-bottom: 4px;
  }
}

.filter-conditions {
  position: relative;
}

.conditions-wrapper {
  position: relative;
  padding-left: 24px;
}

.condition-group {
  position: relative;
  min-height: 32px;
}

.condition-line-wrapper {
  position: absolute;
  left: -16px;
  top: 0;
  bottom: 0;
  width: 16px;

  .condition-line {
    position: absolute;
    left: 0;
    top: 12px;
    bottom: 12px;
    width: 100%;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 2px;
      background-color: #d9d9d9;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 8px;
      height: 2px;
      background-color: #d9d9d9;
    }

    .line-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 8px;
      height: 2px;
      background-color: #d9d9d9;
    }
  }
}

.logic-type {
  position: absolute;
  left: 4%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;

  .ant-radio-group {
    display: flex;
    flex-direction: column;
    background: #e9f0f7;
    border-radius: 4px;

    .ant-radio-button-wrapper {
      margin: 0;
      padding: 2px 4px;
      height: 18px;
      line-height: 14px;
      text-align: center;
      border: none !important;
      background: transparent;
      font-size: 12px;

      &:first-child {
        border-radius: 4px 4px 0 0;
      }

      &:last-child {
        border-radius: 0 0 4px 4px;
      }

      &::before {
        display: none;
      }

      &:hover {
        color: #40a9ff;
        background: #e6f7ff;
      }

      &.ant-radio-button-wrapper-checked {
        color: #fff;
        background: #1890ff;
        box-shadow: none;

        &:hover {
          color: #fff;
          background: #40a9ff;
        }
      }
    }
  }
}

.filter-row {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.condition-content {
  background: #fff;
  padding: 16px;
  border: 1px solid #f0f0f0;
}

.condition-connector {
  position: absolute;
  left: -24px;
  top: 100%;
  bottom: -16px;
  width: 24px;

  .connector-line {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 50%;
    width: 100%;
    border-left: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
  }

  .connector-type {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 0 4px;
    color: #666;
    font-size: 12px;
    line-height: 1;
    border: 1px solid #d9d9d9;
  }
}

.mt-4 {
  margin-top: 16px;
}

@media screen and (max-width: 768px) {
  .conditions-wrapper {
    padding-left: 32px;
  }

  .condition-line-wrapper {
    left: -20px;
    width: 20px;
  }
}
</style>
